import JobWorkerNotInterestedReason from "@/models/JobWorkers/JobWorkerNotInterestedReason";

export default (reason: JobWorkerNotInterestedReason) => {
    let returnVal = "Undefined"
    switch (reason) {
        case JobWorkerNotInterestedReason.Location:
            returnVal = "The location does work";
            break;
        case JobWorkerNotInterestedReason.Position:
            returnVal = "Not interested in this position";
            break;
        case JobWorkerNotInterestedReason.NotLooking:
            returnVal = "Not looking for a job currently";
            break;
        case JobWorkerNotInterestedReason.Salary:
            returnVal = "The salary is too low";
            break;
        default:
            returnVal = "Undefined";
            break;
    }
    return returnVal;
}